import InviteCompany from './InviteCompany'

export default InviteCompany
